module.exports = __webpack_public_path__ + "static/Renault-48fa804a7340c47d73da5dc090683f9c.png";